import { zs } from './zod';

export const longTextField = zs.string().max(20_000);
